import { useDispatch } from 'react-redux'
import { Action } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { ApplicationState } from 'store'

export type ReduxDispatch = ThunkDispatch<ApplicationState, null, Action>
export function useThunkDispatch(): ReduxDispatch {
	return useDispatch<ReduxDispatch>()
}
